var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-item',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
var toggle = ref.toggle;
return [_c('v-btn',{staticClass:"mx-2",staticStyle:{"margin-top":"7px"},attrs:{"input-value":active,"active-class":"primary white--text","depressed":"","to":{ path: '/analytics' }},on:{"click":toggle}},[_c('v-icon',[_vm._v("mdi-chart-pie")]),_c('span',{staticClass:"grey--text",staticStyle:{"margin-left":"5px"}},[_vm._v("Analises")])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }